import { render } from "./ShopSidebar.vue?vue&type=template&id=0f8e4fb1&scoped=true&ts=true"
import script from "./ShopSidebar.vue?vue&type=script&lang=ts"
export * from "./ShopSidebar.vue?vue&type=script&lang=ts"

import "./ShopSidebar.vue?vue&type=style&index=0&id=0f8e4fb1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8e4fb1"]])

export default __exports__